import { Calendar, User } from 'lucide-react';
import SettingsGroup from './SettingsGroup';
import SettingsRow from './SettingsRow';
import { ProfileFormState } from '../profileTypes';

type PersonalInfoCardProps = {
  form: ProfileFormState;
};

const PersonalInfoCard = ({ form }: PersonalInfoCardProps) => (
  <SettingsGroup title='Personal information'>
    <SettingsRow icon={<User size={14} />} label='First name' value={form.firstName || '--'} />
    <SettingsRow icon={<User size={14} />} label='Last name' value={form.lastName || '--'} />
    <SettingsRow icon={<User size={14} />} label='Middle name' value={form.middleName || '--'} />
    <SettingsRow icon={<User size={14} />} label='Occupation' value={form.occupation || '--'} />
    <SettingsRow icon={<Calendar size={14} />} label='Date of birth' value={form.dateOfBirth || '--'} />
  </SettingsGroup>
);

export default PersonalInfoCard;
